import { Box, Card, Skeleton } from "@mui/material";

const ScannedCardSkeleton = ({ count }) => {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <Card
          style={{
            borderRadius: ".5vw",
            padding: ".75vw",
          }}
          key={i}
          sx={{ gap: "0px", width: "21vw", height: "10.5vw" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "2vw",
            }}
            width={"100%"}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between" }}
              width={"100%"}
            >
              <Box className="left" sx={{ gap: ".9vw" }}>
                {/* Style Number with Icon */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: ".5vw" }}
                >
                  <Skeleton variant="circular" width="1vw" height="1vw" />
                  <Skeleton variant="text" width="6vw" height="1vw" />
                </Box>

                {/* Diamond Info with Icon */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: ".5vw" }}
                >
                  <Skeleton variant="circular" width="1vw" height="1vw" />
                  <Skeleton variant="text" width="6vw" height="1vw" />
                </Box>

                {/* Weight Info with Icon */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: ".5vw" }}
                >
                  <Skeleton variant="circular" width="1vw" height="1vw" />
                  <Skeleton variant="text" width="6vw" height="1vw" />
                </Box>

                {/* Size Info with Icon */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: ".5vw" }}
                >
                  <Skeleton variant="circular" width="1vw" height="1vw" />
                  <Skeleton variant="text" width="3vw" height="1vw" />
                </Box>

                {/* Quantity Input */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: ".6vw" }}
                >
                  <Skeleton variant="circular" width="1vw" height="1vw" />
                  <Skeleton
                    variant="rectangular"
                    width="2.2vw"
                    height="1vw"
                    sx={{ borderRadius: ".2vw" }}
                  />
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "1vw",
              }}
            >
              <Box
                style={{
                  width: "fit-content",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {/* Product Image */}
                <Skeleton
                  variant="rectangular"
                  width="8vw"
                  height="8vw"
                  sx={{ borderRadius: ".25vw" }}
                />

                {/* Modify Button */}
                <Skeleton
                  variant="rectangular"
                  sx={{
                    position: "absolute",
                    bottom: "0vw",
                    borderRadius: ".25vw",
                    width: "80%",
                    height: "3.5vh",
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Card>
      ))}
    </>
  );
};

export default ScannedCardSkeleton;
